import FormFile from '../components/FormFile';
import FormDate from '../components/FormDate';
import FormSelect from '../components/FormSelect';
import FormTimeRange from '../components/FormTimeRange';
import FormInput from '../components/FormInput';
import { createInputTypeMap } from '../functions';
import { FormCheckBox } from '../components';
var inputTypeMap = createInputTypeMap({
    file: FormFile,
    date: FormDate,
    select: FormSelect,
    timeRange: FormTimeRange,
    text: FormInput,
    checkbox: FormCheckBox
});
export default inputTypeMap;
//# sourceMappingURL=inputTypeMap.js.map